import React, {useState} from "react";
import {RiUser6Line} from "react-icons/ri";
import {HiOutlineLockClosed} from "react-icons/hi2";
import {LuHeadset} from "react-icons/lu";
import apiRequests from "../axios/config/config";
import toast from "react-hot-toast";
import WebLogo from "../../font & image/image/webLogo.png"
import gmail from "../../font & image/image/gmail.png"
import Loading from "../Loading/Loading";
import {useNavigate} from "react-router-dom";
import bannerImage from '../../font & image/image/imageLoginPage.png'



export default function Login() {


    const navigate  = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);


    function loginAPI() {


        setLoading(true);
        apiRequests.post("/api/admin/v1/login", {
            userName: username,
            password: password,
        })
            .then((response) => {
                localStorage.setItem("accessToken", response.data.data.tokens.accessToken);
                toast.success("Login successful");
                window.location.reload()
            })
            .catch((err) => {

            })
            .finally(() => setLoading(false))
    }

    return (

        <div className="grid grid-cols-2 md:flex md:h-screen md:justify-center md:items-center">

            <div className="flex justify-center h-full items-center p-3 text-center col-span-1 ">
                <div
                    className="text-black border-2 overflow-hidden rounded-lg bg-white p-8 w-[60%] md:w-full items-center justify-center flex flex-col gap-5">

                    <div className="flex items-center justify-center gap-4">
                        <img src={WebLogo} alt="webLogo" width={32} height={32}/>
                        <p className="text-3xl font-bold italic">goalafarin</p>
                    </div>

                    <div className="flex flex-col justify-start gap-1 w-full">
                        <p className="text-xl text-left">User Name</p>
                        <div className="bg-[#D9D9D9] flex items-center justify-between px-5 py-2 rounded-lg ">
                            <input className="bg-transparent outline-0 placeholder:text-[12px] w-full"
                                   value={username}
                                   onChange={(e) => setUsername(e.target.value)}
                                   placeholder="Enter Your Username..."/>
                            <RiUser6Line className="text-[18px] text-firstColor-shade5"/>
                        </div>
                    </div>


                    <div className="flex flex-col justify-start gap-1 w-full">
                        <p className="text-xl text-left">Password</p>
                        <div className="bg-[#D9D9D9] flex items-center justify-between px-5 py-2 rounded-lg">
                            <input className="bg-transparent outline-0 placeholder:text-[12px]  w-full"
                                   type="password"
                                   value={password}
                                   onChange={(e) => setPassword(e.target.value)}
                                   placeholder="Enter Your Password..."/>
                            <HiOutlineLockClosed className="text-[18px] text-firstColor-shade5"/>
                        </div>
                    </div>


                    {/*<div className="hover:text-blue-400 hover:cursor-pointer">Forget Your Password ?</div>*/}


                    <button className="bg-buttonColor-shade6 w-full text-white px-5 py-2 rounded-lg"
                            onClick={loginAPI}
                    >
                        {loading ?
                            <Loading textColor="white-0"/>
                            :
                            "Sign In"

                        }
                    </button>


                </div>
            </div>


            <div className="col-span-1 h-screen md:hidden">
                <img src={bannerImage} alt="baaner" style={{ height: "100%" }} />
            </div>


        </div>


    )
}



